import { createFileRoute, Navigate } from "@tanstack/react-router";
import { HeroSection } from "@/components/marketing/sections/hero-section";
import { FeaturesListSection } from "@/components/marketing/sections/features-list-section";
import { FeaturedCourseSection } from "@/components/marketing/sections/featured-course-section";
import { AccessibilitySection } from "@/components/marketing/sections/accessibility-section";
import { TestimonialSection } from "@/components/marketing/sections/testimonial-section";
import { useAuthStore } from "@/stores/authStore";

export const Route = createFileRoute("/_marketing/")({
  component: Home,
});

function Home() {
  const { isAuthenticated, isLoading, isInitialized } = useAuthStore();

  // Redirect authenticated users to my-learning dashboard
  if (isInitialized && !isLoading && isAuthenticated) {
    return <Navigate to="/my-learning" />;
  }

  // Grounds alternate surface / white, then the navy testimonial; the layout's Footer adds the newsletter.
  return (
    <>
      <HeroSection />
      <FeaturesListSection />
      <FeaturedCourseSection />
      <AccessibilitySection heading="Easy to use, for everyone" intro={null} />
      <TestimonialSection />
    </>
  );
}
